import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { log } from 'util';
import { SecteurService } from 'src/app/service/secteur.service';
import { ProspectService } from 'src/app/service/prospect.service';
import { Secteur, Pays, Prospect } from 'src/app/entity/prospect';
import { FactureService } from 'src/app/service/facture.service';
import { Socifact } from 'src/app/entity/Facture';

interface Food {
  value: string;
  viewValue: string;
}
export interface Userd {
  name: string;
}
@Component({
  selector: 'app-personal-form',
  templateUrl: './personal-form.component.html',
  styleUrls: ['./personal-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class PersonalFormComponent {
  // Receive FormGroup instance from the parent 'NewContactComponent'
  @Input() form: FormGroup;
  @Input() typeClient: string;
  @Input() selectedProspect: Prospect;
  secteurs: Observable<Secteur[]>;
  visibleCountry:boolean;
  //payss: Observable<Pays[]>;
  selectedLangue: string
  filteredOptions: Observable<Userd[]>;
  languages: { label: string; value: string; }[];
  socifactChanged: boolean;
  deviseChanged: boolean;
  socifacts: Observable<Socifact[]>;
  fideliteList: string[] = ['', 'Première participation', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18'];
  /*
      statusjudiciaire: string;
        origineContact:string;
        historique: string;  
  */

  devises = [];
  selectedDevise: string;
  showSave: boolean;
  constructor(private secteurService: SecteurService, private prospectService: ProspectService, private factureService: FactureService) {

  }
  ngOnInit() {
    this.secteurs = this.secteurService.getAll()
    this.onChanges()
    // this.onPaysChanges()
    this.initLanguage();

    this.initSociDevise()

    this.selectedLangue = this.selectedProspect.langue
    if (this.selectedProspect)
      this.selectedDevise = this.selectedProspect.devise;


  }
  initLanguage() {
    this.languages = [
      { label: 'Français', value: 'fr' },
      { label: 'English', value: 'en' },
    ];;
  }
  onChanges(): void {

    /*
          this.form.controls.secteurActivite.valueChanges.subscribe(val => {
      
            if (val) {
              const vals = val + "";
              if (vals.length > 0)
                this.secteurs = this.secteurService.findSecteurbydesignation(val);
      
      
            }
          });
    */
    this.form.disable();
    this.form.valueChanges.subscribe(result => {
      this.showSave = true;
      console.log("vv this.form.valueChange");

      if (this.selectedProspect.sociFact != this.form.value.sociFact) {
        this.selectedProspect.sociFact = this.form.value.sociFact

        this.socifacts.subscribe(result => {
          result.forEach(element => {
            if (element.raisonSocial == this.selectedProspect.sociFact) {
              this.form.controls['devise'].setValue(element.deviseId.symbol);
              this.selectedDevise = element.deviseId.symbol
            }

          });
        })


      }

      this.saveProspect()
    })




  }
  save() {
    this.saveProspect()
  }

  saveProspect() {


    const editedProspect = this.getProspect();
    this.saveProspectDirect(editedProspect);

  }
  saveProspectDirect(editedProspect: Prospect) {


    this.prospectService.saveProspectErp(editedProspect).subscribe(result => {


      this.selectedProspect = result;
      this.showSave = false;
     },



    )
  }
  selectCountry(country:Pays){

    
this.visibleCountry=false;
if(country!=null){
  console.log("countrycountrycountrycountry ",JSON.stringify(country));
  this.form.controls['pays'].setValue(country.designationAn);
 
}

  }
/*
  onPaysChanges(): void {


    this.form.controls.paysActivite.valueChanges.subscribe(val => {

      if (val) {
        const vals = val + "";
        if (vals.length > 0)
          this.payss = this.prospectService.findPaysByDesignation(val);


      }
    });
  }
*/
  changeDevise() {
    //console.log("devisechnaged");

    this.deviseChanged = true;


  }

  changeSociFact() {
    this.socifactChanged = true;

  }



  initSociDevise() {

    this.socifacts = this.factureService.getAllSociFactOrder();
    setTimeout(() => {
      this.form.enable();
    }, 1000);
    this.devises = [
      { label: 'Dinars algérien', value: 'dzd' },
      { label: 'Euro', value: 'eur' },
      { label: 'Dollar des états unis', value: 'usd' },
    ];
  }

  /*   displaySecteurFn(secteur?: Secteur): string | undefined {
       return secteur ? secteur.designation : secteur;
     }*/
  displayPaysFn(pays?: Pays): string | undefined {
    return pays ? pays.designationFr : "";
  }

  /* changeSA(secteur:Secteur){
this.selectedProspect.secteurId=secteur;
this.prospectService.saveProspectErp(this.selectedProspect).subscribe()
   }
 */
  getProspect(): Prospect {

    this.selectedProspect.raisonSocial = this.form.value.raisonSocial;
    this.selectedProspect.signalitique = this.form.value.signalitique;



    this.selectedProspect.nrc = this.form.value.nrc;
    this.selectedProspect.nif = this.form.value.nif;
    this.selectedProspect.nai = this.form.value.nai;
    this.selectedProspect.adresse = this.form.value.adresse;
    this.selectedProspect.pays = this.form.value.pays;
    this.selectedProspect.vatNumber = this.form.value.vatNumber;
    this.selectedProspect.rcNumber = this.form.value.rcNumber;




    //  if (this.form.value.paysActivite instanceof Object)
    //  this.selectedProspect.paysId = this.form.value.paysActivite;


    /// this.selectedProspect.secteur = this.form.value.secteurActivite;
    this.selectedProspect.langue = this.form.value.langue;

    this.selectedProspect.sociFact = this.form.value.sociFact;
    this.selectedProspect.pavillon = this.form.value.pavillon;
    this.selectedProspect.ordre = this.form.value.ordre;


    this.selectedProspect.devise = this.form.value.devise;

    this.selectedProspect.statusjudiciaire = this.form.value.statusjudiciaire;
    this.selectedProspect.origineContact = this.form.value.origineContact;
    this.selectedProspect.historique = this.form.value.historique;


    return this.selectedProspect;
  }
}